import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _Loader;
import { clsx } from 'clsx';
import { Loader } from "../../Loader";
import { ListItemDefault } from "./ListItemDefault";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
/**
 *
 */
export var DropdownListItemsDefault = function DropdownListItemsDefaultInner(_ref) {
  var items = _ref.items,
    isOpen = _ref.isOpen,
    size = _ref.size,
    multilineOption = _ref.multilineOption,
    disabled = _ref.disabled,
    getLiProps = _ref.getLiProps,
    getUlProps = _ref.getUlProps,
    highlightedIndex = _ref.highlightedIndex,
    selectedItem = _ref.selectedItem,
    isLoading = _ref.isLoading;
  var ulProps = getUlProps ? getUlProps({
    disabled: disabled
  }) : {};
  var getClassName = function getClassName() {
    if (isLoading) {
      return 'tw-h-24 tw-flex tw-items-center tw-justify-center';
    }
    if (!isOpen) {
      return 'tw-hidden';
    }
    if ((items === null || items === void 0 ? void 0 : items.length) >= 4) {
      return 'tw-h-24';
    }
    return '';
  };
  return /*#__PURE__*/_jsxs("ul", _objectSpread(_objectSpread({}, ulProps), {}, {
    className: clsx('tw-w-full tw-mt-0.4 tw-list-none tw-z-1 tw-overflow-y-auto tw-bg-neutral-light-100 dark:tw-bg-neutral-dark-700 tw-shadow-03 tw-rounded-1', 'tw-overflow-x-hidden', getClassName(), ulProps.className),
    children: [isLoading ? _Loader || (_Loader = /*#__PURE__*/_jsx(Loader, {})) : null, isOpen && !isLoading && items.map(function (item, index) {
      var liProps = getLiProps ? getLiProps({
        item: item,
        index: index,
        disabled: disabled
      }) : {};
      return /*#__PURE__*/_createElement("li", _objectSpread(_objectSpread({}, liProps), {}, {
        className: clsx('tw-list-none !tw-pr-0', liProps.className),
        key: "".concat(item.value).concat(item.label)
      }), /*#__PURE__*/_jsx(ListItemDefault, {
        highlighted: highlightedIndex === index,
        selected: item.value === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value),
        size: size,
        multilineOption: multilineOption,
        children: item.labelJsx || item.label
      }));
    })]
  }));
};
export default DropdownListItemsDefault;